import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Grid, Card, Button } from "@mui/material/";
import { QueryAPI } from "API/QueryAPI";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import CustomExport from "components/CustomExport";
import moment from 'moment';
import { useNavigate } from "react-router-dom";
import { style } from "style"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation } from 'react-router-dom';
import { checkResponse } from "helpers/notification";
import AlertLoading from "components/AlertLoading";
import AlertNoRecordFound from "components/AlertNoRecordFound";

function FastDetailReport() {

    const navigate = useNavigate();
    const location = useLocation();

    const { queryId, requestParameters } = location.state || {};

    const [fastDetailList, setFastDetailList] = useState(null);

    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);

    var userName = useSelector(state => state.common.userName);
    const [isLoading, setIsLoading] = useState(true);
    const [isDataFetched, setIsDataFetched] = useState(false);

    const getQueryData = async () => {
        setIsLoading(true);
        setIsDataFetched(false);
        setFastDetailList(null);
        setRows([]);
        const getQueryDataResponse = await QueryAPI.GetQueryData(queryId, "firmreportfastotpdetail");
        if (checkResponse(getQueryDataResponse, null, "Detay Rapor getirme işlemi başarısız oldu")) {
            let res = getQueryDataResponse.data.resultObject || [];
            setFastDetailList(res);
            if (res.length === 0) {
                setIsLoading(false);
                setIsDataFetched(true);
            }
        } else {
            setFastDetailList([]);
            setIsLoading(false);
            setIsDataFetched(true);
        }
    };

    const returnToParentQuery = async () => {
        const getCurrentQuery = await QueryAPI.GetQuery(queryId);
        const getParentQuery = await QueryAPI.GetQuery(getCurrentQuery.data.resultObject.parentId);

        const data = {
            queryId: getCurrentQuery.data.resultObject.parentId,
            requestParameters: JSON.stringify(getParentQuery.data.resultObject.requestParameters)
        };

        navigate('/FirmaRaporuDetay', { state: data });
    };

    const createColumns = async e => {
        setColumns([
            {
                headerName: "Id", field: "id", flex: 0, hide: true, disableExport: true,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.id}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Kullanıcı Adı",
                field: "loginName",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.loginName}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Alfanumerik",
                field: "alfanumeric",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.alfanumeric}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Gönderim Adı",
                field: "messageSpecialId",
                flex: 1.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.messageSpecialId}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Gsm",
                field: "recipientMSISDN",
                flex: 1.5,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.recipientMSISDN}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Mesaj Metni",
                field: "messageContent",
                flex: 2,
                hide: true,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.messageContent}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Durum",
                field: "status",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.status}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Hata Kodu",
                field: "reason",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.reason}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Hata Kodu Açıklaması",
                field: "customDescription",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.customDescription}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Gönderim Tarihi",
                field: "insertDate",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {moment(params.row.insertDate).format('YYYY-MM-DD HH:mm')}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "Kaynak IP",
                field: "sourceIp",
                flex: 1,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.sourceIp}
                        </MDTypography>
                    );
                }
            },
            {
                headerName: "smsRefId",
                field: "smsRefId",
                flex: 2,
                renderCell: params => {
                    return (
                        <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
                            {params.row.smsRefId}
                        </MDTypography>
                    );
                }
            },
        ]);
    };

    const createRows = () => {
        if (!Array.isArray(fastDetailList) || fastDetailList.length === 0) {
            setRows([]);
            setIsLoading(false);
            setIsDataFetched(true);
            return;
        }

        const formattedRows = fastDetailList.map((row, index) => ({
            ...row,
            id: index + 1
        }));
        setRows(formattedRows);
        setIsLoading(false);
        setIsDataFetched(true);
    };

    useEffect(() => {
        getQueryData();
    }, [queryId]);

    useEffect(() => {
        createColumns();
    }, []);

    useEffect(() => {
        createRows();
    }, [fastDetailList]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Grid container spacing={0} px={2}>
                <Grid item xs={12} md={12} lg={12}>
                    <Button style={style.buttonStyle} onClick={returnToParentQuery} startIcon={<ArrowBackIcon />}>
                        Firma Raporuna Geri Dön
                    </Button>
                </Grid>
            </Grid>

            <MDBox pt={3} pb={1}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>

                            <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                                <MDTypography variant='h6' color='white'>
                                    Fast Sms Detay Raporu
                                </MDTypography>
                            </MDBox>
                            {isLoading ? (
                                <AlertLoading text="Fast SMS detay raporu yükleniyor..." />
                            ) : isDataFetched && rows.length === 0 ? (
                                <AlertNoRecordFound />
                            ) : (
                                <MDBox pt={3}>
                                    <CustomExport
                                        rows={rows}
                                        columns={columns}
                                        exportFileName={
                                            userName +
                                            "_FastDetayRaporu_" +
                                            moment(new Date()).format('YYYYMMDDHHmmss').toString()
                                        }
                                        contentFieldName="messageContent"
                                    />
                                </MDBox>
                            )}

                        </Card>
                    </Grid>
                </Grid>
            </MDBox>

        </DashboardLayout>
    );
}

export default FastDetailReport;